import { Spin } from 'antd';
import type { OoCaseSidebarContext } from '@components/CaseSidebar/buildOoCaseSidebar';
import { CaseSidebarItemId } from '@components/CaseSidebar/types';
import { FormValidationProvider } from '@hooks/useBtlFormValidation';
import { BtlBaseForm } from '@pages/BtlApplicationFormPage/BtlBaseForm';
import { useNavigate } from 'react-router-dom';
import { OoCaseFormFooter } from '../OoCaseFormFooter';
import { isOoSolicitorsFormEditable, useOoCaseSolicitorsForm } from './useOoCaseSolicitorsForm';

interface CaseSolicitorsPageProps {
  caseId: string;
  sidebarContext: OoCaseSidebarContext;
}

function CaseSolicitorsPageContent({ caseId, sidebarContext }: CaseSolicitorsPageProps) {
  const navigate = useNavigate();
  const form = useOoCaseSolicitorsForm({ caseId, sidebarContext });

  const handleNavigate = (itemId: CaseSidebarItemId) => {
    navigate({ search: `?section=${itemId}` });
  };

  if (form.isLoading) {
    return <Spin size='large' />;
  }

  return (
    <BtlBaseForm
      {...form.formProps}
      submitter={
        form.isFormEditable
          ? {
              render: ({ form: antForm }) => (
                <OoCaseFormFooter
                  {...form.footerProps}
                  form={antForm}
                  isFormEditable
                  showSkipButton={form.showSkipButton}
                  onNavigate={handleNavigate}
                />
              ),
            }
          : false
      }
    />
  );
}

export function CaseSolicitorsPage(props: CaseSolicitorsPageProps) {
  return (
    <FormValidationProvider>
      <CaseSolicitorsPageContent {...props} />
    </FormValidationProvider>
  );
}

export { isOoSolicitorsFormEditable };
